
webpack.register(
    'modules/alert-manager/alert-manager',
    function() {
        return import('modules/alert-manager/alert-manager');
    },
    true
);